import { FC, ReactNode } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { LineData } from './model';
import { CurrencyLabel, OfferPriceLabel, OfferPriceText, PriceBlock } from './ProductOfferPrices.styles';
import { formatPrice, getMonthlyUnit } from './utils';

type Props = {
    line: LineData;
    color?: 'accent' | 'black';
    currencyBold?: boolean;
    size?: 'lg' | 'md';
    trailing?: ReactNode;
};

export const OfferPriceAmounts: FC<Props> = ({ line, color, currencyBold, size, trailing }) => {
    const { t } = useTranslations();
    const defaultPeriod = t['eshop.product_page.product_offer_prices.default_period'];
    const priceSeparator = t['eshop.product_page.product_offer_prices.price_separator'];

    if (line.monthlyPrice) {
        return (
            <>
                <PriceBlock $color={color}>
                    <OfferPriceText $size={size}>{formatPrice(line.monthlyPrice)}</OfferPriceText>
                    <CurrencyLabel $bold={currencyBold}>
                        {getMonthlyUnit(line.monthlyPrice, defaultPeriod)}
                    </CurrencyLabel>
                </PriceBlock>

                <OfferPriceLabel>{priceSeparator}</OfferPriceLabel>

                <PriceBlock $color={color}>
                    <OfferPriceText $size={size}>
                        {`${formatPrice(line.totalPrice)} ${line.totalPrice.currency}`}
                    </OfferPriceText>
                </PriceBlock>

                {trailing}
            </>
        );
    }

    return (
        <>
            <PriceBlock $color={color}>
                <OfferPriceText $size={size}>{formatPrice(line.totalPrice)}</OfferPriceText>
                <CurrencyLabel>{line.totalPrice.currency}</CurrencyLabel>
            </PriceBlock>

            {trailing}
        </>
    );
};
